export default __webpack_public_path__ + "static/media/odyssey-logo.a218d522.svg";